import { Organization } from '@alkem/lib-front-model';
import { TurboSelect } from '@alkem/react-ui-turbo-select';

import Autocomplete from 'components/ui/autocomplete/index';
import { getLocalizedOrganizationName } from 'core/api/organization';
import authApi from 'resources/authApi';

import Addable from '../addable';

const fetchOrganizations = async (input, filters = {}) => {
  const {
    data: { data },
  } = await authApi.OrganizationList(
    { input },
    { ...filters, like_namelegal: input },
    {
      by: 'nameLegal',
      order: 'asc',
    },
    0,
    20,
  );
  return data;
};

export class OrganizationLegacyAutocomplete extends Autocomplete<{
  filters: object;
}> {
  static defaultProps = {
    ...Autocomplete.defaultProps,
    filters: {},
  };

  getList(input) {
    return fetchOrganizations(input, this.props.filters).then((data) => {
      this.updateList(
        data.map((organization) => ({
          label: getLocalizedOrganizationName(organization),
          id: organization.id,
        })),
      );
    });
  }
}

export const OrganizationLegacyAddableAutocomplete = Addable(
  OrganizationLegacyAutocomplete,
);

export const OrganizationAutocomplete = (props) => {
  return (
    <TurboSelect<Organization>
      loadOptions={fetchOrganizations}
      isSearchable
      getOptionValue={({ id }) => id}
      getOptionLabel={({ nameLegal }) => nameLegal}
      {...props}
    />
  );
};

export default OrganizationLegacyAutocomplete;
